import { BranchMappingListPage } from "@/features/branch-sales-channel/pages/BranchMappingListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/branch-sales-channel/")({
	beforeLoad({ context }) {
		// The list query is guarded by masterdata.lookup on the BE; there is no
		// branch_sales_channel_merchant_maps.view scope.
		if (!context.authAdapter.can({ permissions: ["masterdata.lookup"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: BranchMappingListPage,
});
